import React, { useState, useEffect } from 'react';
import styles from './styles.module.css';
import authUtils from 'utils/auth';
import dxApi from 'services/dxApi';
import { CircularProgress } from '@mui/material';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const WellhubUnitsHistory = ({
  loadingGympassHistory,
  loadGympassHistory,
  gympassHistoryData,
}) => {
  const currentDate = new Date();
  const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
  const formatDate = date => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  const [selectedStartDate, setSelectedStartDate] = useState(firstDayOfMonth);
  const [selectedEndDate, setSelectedEndDate] = useState(currentDate);
  const [selectedLocation, setSelectedLocation] = useState('');
  const [historyData, setHistoryData] = useState([]);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(null);
  const minDate = new Date('01-01-2018');

  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  const locations = [
    {
      id: 6,
      name: 'Marin',
    },
    {
      id: 7,
      name: 'Oakland',
    },
    {
      id: 5,
      name: 'SF Castro',
    },
    {
      id: 1,
      name: 'SF Embarcadero',
    },
    {
      id: 4,
      name: 'SF Fillmore',
    },
    {
      id: 2,
      name: 'SF Mid Market',
    },
    {
      id: 3,
      name: 'SF SOMA',
    },
    {
      id: 8,
      name: 'SF Transbay',
    },
  ];
  const currentYear = new Date().getFullYear();

  const CustomHeader = ({
    date,
    changeYear,
    changeMonth,
    decreaseMonth,
    increaseMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled,
  }) => {
    const currentMonth = new Date().getMonth();
    const selectedYear = date.getFullYear();
    const isCurrentYear = selectedYear === currentYear;

    return (
      <div
        style={{
          margin: 10,
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <button
          onClick={decreaseMonth}
          disabled={prevMonthButtonDisabled}
          style={{
            marginRight: '10px',
          }}
        >
          {'<'}
        </button>
        <select
          value={date.getFullYear()}
          onChange={({ target: { value } }) => changeYear(value)}
          style={{
            border: '1px solid black',
            marginRight: '10px',
          }}
        >
          {Array.from({ length: currentYear - 2017 }, (_, i) => 2018 + i).map(year => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>

        <select
          value={date.getMonth()}
          onChange={({ target: { value } }) => changeMonth(value)}
          style={{
            border: '1px solid black',
            marginRight: '5px',
          }}
        >
          {months.map((month, index) => (
            <option
              key={month}
              value={index}
              disabled={isCurrentYear && index > currentMonth}
            >
              {month}
            </option>
          ))}
        </select>
        <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
          {'>'}
        </button>
      </div>
    );
  };

  const DateFormatter = dateString => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${month}-${day}-${year}`;
  };

  function convertDateFormat(dateString) {
    const date = new Date(dateString);
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    return `${month}-${year}`;
  }

  const admin_access_token = authUtils.getAdminToken();

  const historyHeading = ['Wellhub Id', 'Full Name', 'Gym Name', 'First Visit', 'Month'];

  const handleStartDateChange = date => {
    setSelectedStartDate(date);
  };

  const handleEndDateChange = date => {
    setSelectedEndDate(date);
  };

  const handleLocationChange = event => {
    setSelectedLocation(event.target.value);
  };

  const handleGetHistoryClick = () => {
    if (selectedStartDate && selectedEndDate) {
      if (!(selectedEndDate >= selectedStartDate)) {
        alert('End date must be greater than or equal to Start date.');
      } else {
        const formatStartDate = formatDate(selectedStartDate);
        const formatEndDate = formatDate(selectedEndDate);
        const payload = {
          startRange: formatStartDate,
          endRange: formatEndDate,
          pageIndex: 1,
          pageSize: rowsPerPage,
          locationId: +selectedLocation,
        };
        loadGympassHistory(payload);
        setSelectedStartDate(selectedStartDate);
        setSelectedEndDate(selectedEndDate);
        setSelectedLocation(selectedLocation);
        setPage(1);
      }
    } else {
      alert('Please fill out all fields.');
    }
  };

  useEffect(() => {
    if (!(selectedEndDate >= selectedStartDate)) {
      alert('End date must be greater than or equal to Start date.');
    } else {
      dxApi.setAuthTokenToHeader(admin_access_token);
      const formatStartDate = formatDate(selectedStartDate);
      const formatEndDate = formatDate(selectedEndDate);
      const payload = {
        startRange: formatStartDate,
        endRange: formatEndDate,
        pageIndex: page,
        pageSize: rowsPerPage,
        locationId: +selectedLocation,
      };
      loadGympassHistory(payload);
      setSelectedStartDate(selectedStartDate);
      setSelectedEndDate(selectedEndDate);
      setSelectedLocation(selectedLocation);
    }
  }, [page, rowsPerPage]);

  useEffect(() => {
    setHistoryData(gympassHistoryData?.data);
    setTotalPages(gympassHistoryData?.totalPages);
    setTotalRecords(gympassHistoryData?.totalItems);
  }, [gympassHistoryData]);

  const handleNextPage = () => {
    if (page < totalPages) setPage(page + 1);
  };

  const handlePreviousPage = () => {
    if (page > 1) setPage(page - 1);
  };

  const handleRowsPerPageChange = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  return (
    <>
      <div className={`${styles.wrapper}`}>
        <div className={styles.textDiv}>
          <p className={styles.text}>Wellhub Units History:</p>
        </div>
        <hr className={styles.divider} />
        <div className={styles.innerContainer}>
          <div className={styles.inputContainer}>
            <div className={styles.inputDiv}>
              <p className={styles.label}>Start Date:</p>
              <DatePicker
                renderCustomHeader={props => <CustomHeader {...props} />}
                selected={selectedStartDate}
                onChange={date => handleStartDateChange(date)}
                className={styles.select}
                dateFormat="MM-dd-yyyy"
                fixedHeight
                maxDate={currentDate}
                minDate={minDate}
                todayButton="Today"
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
              />
            </div>
            <div className={styles.inputDiv}>
              <p className={styles.label}>End Date:</p>
              <DatePicker
                renderCustomHeader={props => <CustomHeader {...props} />}
                selected={selectedEndDate}
                onChange={date => handleEndDateChange(date)}
                className={styles.select}
                dateFormat="MM-dd-yyyy"
                fixedHeight
                maxDate={currentDate}
                minDate={minDate}
                todayButton="Today"
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
              />
            </div>
            <div className={styles.inputDiv}>
              <p className={styles.label}>Location:</p>
              <select
                value={selectedLocation}
                onChange={handleLocationChange}
                className={styles.locationSelect}
              >
                <option value={''}>Select</option>
                {locations.map(location => (
                  <option key={location.id} value={location.id}>
                    {location.name}
                  </option>
                ))}
              </select>
            </div>
            <div className={styles.inputDiv}>
              <button className={styles.addButton} onClick={handleGetHistoryClick}>
                Get History
              </button>
            </div>
          </div>
        </div>
        <div className={styles.labelsContainer}>
          <p
            style={{
              textTransform: 'capitalize',
              fontWeight: 'bold',
            }}
          >
            {totalRecords ? `History: (${totalRecords})` : 'History:'}
          </p>
        </div>
        <div className={styles.tablesContainer}>
          <div className={styles.tableContainer}>
            <table>
              <thead>
                <tr>
                  {historyHeading.map((head, headID) => (
                    <th key={headID}>{head}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {loadingGympassHistory ? (
                  <tr>
                    <td colSpan="5">
                      <CircularProgress size={18} style={{ color: '#FE5000' }} />
                    </td>
                  </tr>
                ) : historyData?.length ? (
                  historyData?.map((unit, index) => (
                    <tr key={index}>
                      <td>{unit.gympassId}</td>
                      <td>
                        {unit.firstName} {unit.lastName}
                      </td>
                      <td>{unit.clubName}</td>
                      <td>{DateFormatter(unit.createdDate)}</td>
                      <td>{convertDateFormat(unit.createdDate)}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5">No History Available</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        {!loadingGympassHistory && totalPages ? (
          <div className={styles.paginationDiv}>
            <div className={styles.paginationControls}>
              <div className={styles.paginationRowsPerPageDiv}>
                <span>Rows per page:</span>
                <select value={rowsPerPage} onChange={handleRowsPerPageChange}>
                  <option value={10}>10 rows</option>
                  <option value={25}>25 rows</option>
                  <option value={50}>50 rows</option>
                  <option value={100}>100 rows</option>
                </select>
              </div>
              <div className={styles.paginationButtonsDiv}>
                <button onClick={handlePreviousPage} disabled={page === 1}>
                  Previous
                </button>
                <span>
                  Page {page} of {totalPages}
                </span>
                <button onClick={handleNextPage} disabled={page === totalPages}>
                  Next
                </button>
              </div>
            </div>
          </div>
        ) : (
          ''
        )}
      </div>
    </>
  );
};

export default WellhubUnitsHistory;
